import { Box, Divider, Typography } from "@mui/material";
import { LoadMoreButton } from "Components/Affiliate/Stats/LoadMoreButton";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { Fragment } from "react";
import { formatDate } from "Utils/DateUtils";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  items: Array<{
    email?: string | null;
    dateCreated?: string | null;
    dateUpdated?: string | null;
  }>;
  dateVariant: "created" | "updated";
  isLoading?: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
};

export const LeadList = ({
  items,
  dateVariant = "created",
  isLoading,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
}: Props) => {
  const { t } = useResource();
  const anonymousUserText = t(Resources.Common.AnonymousUser);

  if (isLoading) {
    return (
      <Box my={4}>
        <CenteredCircularProgress />
      </Box>
    );
  }

  if (isFetchingNextPage) {
    <Box mt={4}>
      <CenteredCircularProgress size={20} />
    </Box>;
  }

  return (
    <Box component="ul" p={0} m={0}>
      {items.map(({ email, dateCreated, dateUpdated }, index) => {
        const isLast = index === items.length - 1;
        const date = dateVariant === "created" ? dateCreated : dateUpdated;

        return (
          <Fragment key={email || index}>
            <Box
              component="li"
              my={1.5}
              gap={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ listStyle: "none" }}
            >
              <Typography variant="body1" fontWeight={400}>
                {email || anonymousUserText}
              </Typography>
              {date && (
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "nowrap" }}
                  fontWeight={300}
                >
                  {formatDate(date)}
                </Typography>
              )}
            </Box>
            {!isLast && <Divider sx={{ opacity: 0.3 }} />}
          </Fragment>
        );
      })}
      <LoadMoreButton
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </Box>
  );
};
